import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.grouped-table {
  & table.p-datatable-table,
  & table.app-table {
    table-layout: fixed;
  }
  & .grouped-table-expanded .p-datatable-thead th,
  & .grouped-table-expanded .p-datatable-tbody td,
  & .grouped-table-expanded .app-table-thead th,
  & .grouped-table-expanded .app-table-tbody td {
    border: none !important;
    border-bottom: 1px solid ${dt('surface.200')} !important;
  }
  & tr.grouped-table-group-row {
    background-color: ${dt('groupedTable.groupRow.background')};

    & div.expand-or-collapse-control {
      color: ${dt('groupedTable.groupRow.expandOrCollapseControl.color')};

      & span {
        font-size: ${dt('groupedTable.groupRow.expandOrCollapseControl.size')};
      }
    }

    & span.name {
      color: ${dt('groupedTable.groupRow.name.color')};
      font-weight: ${dt('groupedTable.groupRow.name.fontWeight')};
      font-size: ${dt('groupedTable.groupRow.name.fontSize')};
      line-height: ${dt('groupedTable.groupRow.name.lineHeight')};
    }

    & span.subtitle {
      color: ${dt('groupedTable.groupRow.subtitle.color')};
      font-weight: ${dt('groupedTable.groupRow.subtitle.fontWeight')};
      font-size: ${dt('groupedTable.groupRow.subtitle.fontSize')};
      line-height: ${dt('groupedTable.groupRow.subtitle.lineHeight')};
    }

    & span.item-count {
      color: ${dt('groupedTable.groupRow.itemCount.color')};
      font-weight: ${dt('groupedTable.groupRow.itemCount.fontWeight')};
      font-size: ${dt('groupedTable.groupRow.itemCount.fontSize')};
      line-height: ${dt('groupedTable.groupRow.itemCount.lineHeight')};
    }
  }

  & .grouped-table-expanded {
    color: ${dt('groupedTable.detailRow.primaryDataItem.color')};
    padding-left: 0;
  }
  & .grouped-table-expanded .p-datatable-thead th,
  & .grouped-table-expanded .app-table-thead th {
    background-color: ${dt('content.background')};
  }
  & .grouped-table-expanded .p-datatable-thead th,
  & .grouped-table-expanded .p-datatable-tbody td:not(.app-data-table-empty),
  & .grouped-table-expanded .app-table-thead th,
  & .grouped-table-expanded .app-table-tbody td:not(.app-data-table-empty) {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  & .grouped-table-expanded .p-datatable-thead th:first-child,
  & .grouped-table-expanded .p-datatable-tbody td:first-child:not(.app-data-table-empty),
  & .grouped-table-expanded .app-table-thead th:first-child,
  & .grouped-table-expanded .app-table-tbody td:first-child:not(.app-data-table-empty) {
    padding-left: ${dt('groupedTable.expandCell.width')} !important;
  }

  & tr.grouped-table-detail-row {
    & span.primary-data-item {
      color: ${dt('groupedTable.detailRow.primaryDataItem.color')};
      font-weight: ${dt('groupedTable.detailRow.primaryDataItem.fontWeight')};
      font-size: ${dt('groupedTable.detailRow.primaryDataItem.fontSize')};
      line-height: ${dt('groupedTable.detailRow.primaryDataItem.lineHeight')};
    }

    & span.secondary-primary-data-item {
      color: ${dt('groupedTable.detailRow.secondaryDataItem.color')};
      font-weight: ${dt('groupedTable.detailRow.secondaryDataItem.fontWeight')};
      font-size: ${dt('groupedTable.detailRow.secondaryDataItem.fontSize')};
      line-height: ${dt('groupedTable.detailRow.secondaryDataItem.lineHeight')};
    }
  }

}

.grouped-table.grouped-table-with-expand table.p-datatable-scrollable-table th.grouped-table-expand-cell,
.grouped-table.grouped-table-with-expand table.p-datatable-scrollable-table td.grouped-table-expand-cell {
  width: ${dt('groupedTable.expandCell.width')} !important;
  min-width: ${dt('groupedTable.expandCell.width')} !important;
  max-width: ${dt('groupedTable.expandCell.width')} !important;
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
  box-sizing: border-box;
}
.grouped-table.grouped-table-with-expand th.grouped-table-expand-cell + th,
.grouped-table.grouped-table-with-expand td.grouped-table-expand-cell + td {
  padding-left: 0.5rem !important;
}
`;
